import { render, staticRenderFns } from "./ui-modal.vue?vue&type=template&id=ca6e4f0e&scoped=true&"
import script from "./ui-modal.vue?vue&type=script&lang=js&"
export * from "./ui-modal.vue?vue&type=script&lang=js&"
import style0 from "./ui-modal.vue?vue&type=style&index=0&id=ca6e4f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6e4f0e",
  null
  
)

export default component.exports